

































































































































import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { Component, Prop } from 'vue-property-decorator';
import UUIFComponents from '@/shared/uuifComponent';
import { SwContentToolbar } from '@sonicwall/unified-ui-framework/src/shared/sw-content-toolbar';
import { SwSpinningProgress } from '@sonicwall/unified-ui-framework/src/shared/sw-progress';
import { SwIconButton } from '@libs-uuif/shared/sw-icon-button';
import { SwDropMenu, DropMenuItem } from '@libs-uuif/shared/sw-drop-menu';
import { SwTable, TableEntry, TableColumnConfig } from '@sonicwall/unified-ui-framework/src/shared/sw-table';
import { SwForm, SwFormRow } from '@sonicwall/unified-ui-framework/src/shared/sw-form';
import { SwActionBar, SwActionBarItem } from '@sonicwall/unified-ui-framework/src/shared/sw-action-bar';
import { SwExpandableTextfield, SwTextarea } from '@sonicwall/unified-ui-framework/src/shared/sw-textfield';
import { SelectOption, SwSelect } from '@sonicwall/unified-ui-framework/src/shared/sw-select';
import { CreateElement, VNode } from 'vue';
import { required } from 'vuelidate/lib/validators';
import { InfoState } from '../../../core/core.store';
const cssPrefix = 'quotenotes';

@Component({
  components: {
    ...UUIFComponents,
    SwSpinningProgress,
    SwContentToolbar,
    SwTable,
    SwExpandableTextfield,
    SwDropMenu,
    SwIconButton,
    SwForm, SwFormRow,
    SwActionBar, SwActionBarItem,
    SwSelect,
    SwTextarea,
  },
  validations:{
    addQuoteNote: {
      equoteId: { required },
      notes: { required },
    },
  },
})

export default class QuotenotesModal extends SwExtendedVue {
  cssPrefix = cssPrefix;
  @Prop()
  showQuoteNotesDialog: boolean;
  @Prop()
  quoteId: string;
  searchValue: string = '';
  selectedMenuItem:string = '';
  quotenotesColumnConfig: TableColumnConfig[] = [];
  quotenotesTableData:TableEntry[] = [];
  tempQuoteNotesTableData: TableEntry[] = [];
  quotenotesFilterItems: DropMenuItem[] = [
    {
      id: 'notesDate',
      content: this.$t('quote.date')
      .toString(),
    },
    {
      id: 'userName',
      content: this.$t('profile.username')
      .toString(),
    },
    {
      id: 'eventName',
      content: this.$t('renewalManager.event')
      .toString(),
    },
    {
      id: 'equoteId',
      content: this.$t('quote.quoteID')
      .toString(),
    },
    {
      id: 'description',
      content: this.$t('quote.description')
      .toString(),
    },
  ];
  // search & filter
  textExpanded : boolean = false;
  search: string = '';
  filterSearch: string = '';
  appliedFilter : any = [];
  quoteMenuOpened: boolean = false;
  showSearchedTextInHeader : boolean = false;
  showFilterSearch: boolean = false;
  filterHoverValues : boolean = false;
  showAddNotesModal: boolean = false;
  quoteIdMenu: SelectOption[] = [
    {
      id: '1',
      label: this.$t('renewalManager.selectQuoteId')
      .toString(),
      value:'',
    },
  ];
  selectedQuote: string = '1';
  qouteNotes: string = '';
  addQuoteNote = {
    equoteId: '1',
    notes: '',
  };
  onClickQuoteNotesFilterButton(filterItem : any, hoverFilter : boolean = false) {
    this.quoteMenuOpened = !this.quoteMenuOpened;
    let removeIndex : number = -1;
    this.quotenotesFilterItems.forEach((element: any, i: number) => {
      if (element.id === filterItem) {
        removeIndex = i;
      }
    });
    if (removeIndex !== -1) {
      this.appliedFilter.push(
        { id: this.quotenotesFilterItems[removeIndex].id,
          content: this.quotenotesFilterItems[removeIndex].content,
          value: this.filterSearch,
        });
      if (hoverFilter) {
        this.filterHoverValues = true;
      }
      this.filterSearch = '';
      this.showFilterSearch = true;
    }
  }

  onCloseAll() {
    this.searchValue = '';
    this.selectedMenuItem = '';
    this.quoteMenuOpened = false;
  }
  makeTableConfig() {
    // const makeElipsis = (item: string, size = 20) => {
    //   if (item.length > size) {
    //     return `${item.slice(0, size)}...`;
    //   } return item;
    // };
    const tableConfig: TableColumnConfig[] = [
      {
        key: 'index',
        type: 'index',
      },
      {
        key: 'addedBy',
        dataKey: 'addedBy',
        title: this.$t('renewalManager.addedBy')
        .toString(),
        sorter: true,
        width: 150,
        // tslint:disable-next-line:no-unused
      },
      {
        key: 'createdDate',
        dataKey: 'createdDate',
        title: this.$t('quote.batchDate')
        .toString(),
        width: 150,
        // tslint:disable-next-line:no-unused
      },
      {
        key: 'equoteId',
        dataKey: 'equoteId',
        title: this.$t('quote.quoteID')
        .toString(),
        sorter: true,
        width: 100,
        // tslint:disable-next-line:no-unused
      },
      {
        key: 'noteDesc',
        dataKey: 'noteDesc',
        title: this.$t('quote.note')
        .toString(),
        width: 200,
        // tslint:disable-next-line:no-unused
        render: (h: CreateElement, data: { entry: TableEntry }): VNode => {
          return (
            <div>
              { data.entry.noteDesc }
            </div>
          ) as VNode;
        },
      },
    ];
    this.quotenotesColumnConfig = tableConfig;
  }

  makeTableData() {
    this.$store.dispatch('RenewalManagerStoreModule/getQuoteNotes', this.quoteId)
    .then((res:any) => {
      this.$store.commit('stopLoading');
      if (res.operationStatus === 'OK' && res.msgCode === 'MSWAPP:SUCCESS') {
        this.$store.commit('RenewalManagerStoreModule/setQuoteNotes', res.respList);
        const tableData = this.$store.getters['RenewalManagerStoreModule/getQuoteNotes'].map((el: any, index: any) => {
          return {
            ...el,
            _key: index,
          };
        });
        this.quotenotesTableData = tableData;
        this.tempQuoteNotesTableData = tableData;
      }
    });
  }
  get tableHeight() {
    return 'calc(100vh - 430px)';
  }

  initiateFilter(event : any, filterId : number) {
    if (event.keyCode === 13) {
      if (filterId === undefined) {
        this.applyFilter();
      } else {
        this.setFilterValue(event, filterId);
      }
    }
  }

  globalFilter(event : any, filterId : number) {
    if (event.keyCode === 13) {
      if (filterId === undefined) {
        this.applyFilter();
      } else {
        this.setFilterValue(event, filterId);
      }
    }
  }

  applyFilter(isExternal: boolean = false) {
    // this.filterHoverValues = false;
    if (!isExternal) {
      this.quotenotesTableData = this.tempQuoteNotesTableData;
    }
    if (this.appliedFilter.length > 0) {
      this.appliedFilter.forEach((element : any) => {
        this.quotenotesTableData = this.quotenotesTableData.filter((order : any) => {
          const elementValueArray = element.value.split(',');
          const srcValue = order[element.id].toUpperCase();
          let flag = 0;
          elementValueArray.every((elementValue : any) => {
            if (srcValue.indexOf(elementValue.trim()
            .toUpperCase()) >= 0) {
              flag = 1;
              return false;
            }
            if (srcValue.indexOf(elementValue.trim()
            .toUpperCase()) < 0) {
              return true;
            }
          });
          if (flag === 1) {
            return true;
          }
        });
      });
    }
    if (this.search !== '') {
      this.textExpanded = false;
      const key : string = this.search.toUpperCase();
      let flag : number = 0;
      const searchKeys = ['notesDate', 'description', 'equoteId', 'eventName', 'userName'];
      this.quotenotesTableData = this.quotenotesTableData.filter((item : any) => {
        flag = 0;
        searchKeys.forEach((field) => {
          if (item[field] && (item[field].toUpperCase()).indexOf(key) >= 0) {
            flag = 1;
            return false;
          }
          if (item[field] && (item[field].toUpperCase()).indexOf(key) < 0) {
            return true;
          }
        });
        if (flag === 1) {
          return true;
        }
      });
      this.showSearchedTextInHeader = true;
    }
  }

  setFilterValue(event = undefined, index: number) {
    if (event !== undefined && this.filterSearch === '') {
      this.removeFilterBox(index);
    } else {
      this.appliedFilter.forEach((element : any, i : number) => {
        if (i === index) {
          if (event !== undefined) {
            element.value = this.filterSearch;
            this.showFilterSearch = false;
          }
        }
      });
      this.applyFilter();
    }
  }

  clearFilter() {
    this.search = '';
    this.showSearchedTextInHeader = false;
    this.applyFilter();
  }

  clearAllFilters() {
    this.appliedFilter.forEach((element : any) => {
      element.value = '';
    });
    this.appliedFilter = [];
    this.search = '';
    this.showFilterSearch = false;
    this.applyFilter();
  }

  removeFilterBox(id: number) {
    let removeIndex = -1;
    this.filterSearch = '';
    this.appliedFilter.forEach((element : any, i : number) => {
      if (element.id === id) {
        element.value = '';
        removeIndex = i;
      }
    });
    this.appliedFilter.splice(removeIndex, 1);
    this.applyFilter();
  }

  makeAddNotesVisible() {
    this.showAddNotesModal = true;
    if (this.quoteIdMenu.length > 1) {
      this.quoteIdMenu.pop();
    }
    this.quoteIdMenu.push({ id: '2', label: this.quoteId, value: this.quoteId });
  }

  addNewNote() {
    if (this.checkValidation()) {
      if (this.addQuoteNote.equoteId === '1') {
        const message: InfoState = {
          infoType: 'high',
          infoMsg: this.$t('renewalManager.qIdEmptyMsg')
        .toString(),
        };
        this.$store.commit('displayMessage', message);
      } else {
        const quoteid = this.quoteIdMenu.map((element: any) => {
          if (element.id === this.addQuoteNote.equoteId) {
            return element.value;
          }
        });
        const req = {
          equoteId: quoteid[1],
          note: this.addQuoteNote.notes,
        };
        this.$store.dispatch('RenewalManagerStoreModule/addQuoteNote', req)
        .then((res:any) => {
          this.$store.commit('stopLoading');
          if (res.operationStatus === 'OK' && res.msgCode === 'MSWAPP:ADDEQUOTENOTE') {
            const message: InfoState = { infoType: 'success', infoMsg: res.msgCode };
            this.$store.commit('enqueueMessage', message);
            this.makeTableData();
            this.showAddNotesModal = false;
          } else {
            const message: InfoState = { infoType: 'failed', infoMsg: res.msgCode };
            this.$store.commit('enqueueMessage', message);
          }
        });
      }
    }
  }

  checkValidation() {
    this.$v!.addQuoteNote!.equoteId!.$touch();
    this.$v!.addQuoteNote!.notes!.$touch();
    return !this.$v!.addQuoteNote!.equoteId!.$invalid &&
        this.$v!.addQuoteNote!.equoteId!.$dirty &&
        this.$v!.addQuoteNote!.equoteId!.required &&
        this.$v!.addQuoteNote!.notes!.$dirty &&
        !this.$v!.addQuoteNote!.notes!.$invalid &&
        this.$v!.addQuoteNote!.notes!.required;
  }

  cancelAddNote() {
    this.showAddNotesModal = false;
    this.addQuoteNote.equoteId = '1';
    this.addQuoteNote.notes = '';
  }

  mounted() {
    this.makeTableData();
    this.makeTableConfig();
  }
  closeQuoteNotesDialog() {
    this.$emit('closeQuoteNotesDialog');
  }
}
